import { mergeDefaults as _mergeDefaults, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots } from "vue"

import {
  BaseFieldEmits,
  defaultValuedProps,
  useBaseFieldProps,
  ValuedFieldProps,
} from 'SharedComponents/Fields/composables/useBaseFieldProps';
import useFieldParams from 'SharedComponents/Fields/composables/useFieldParams';
import { useTooltip } from 'SharedComponents/Fields/composables/useFieldTooltip';
import FieldHistoryBtn from 'SharedComponents/Fields/FieldHistoryBtn.vue';
import SCheckbox from 'SharedComponents/ui/Checkbox/SCheckbox.vue';
import Tooltip from 'SharedComponents/ui/Tooltip.vue';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { CheckboxFieldParams, FieldValue } from 'SharedDir/declarations/fields';

type CheckboxFieldProps = ValuedFieldProps &
  PropValue<FieldValue<boolean> | null> & {
    params: CheckboxFieldParams;
  };


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'CheckboxField' },
  __name: 'CheckboxField',
  props: /*@__PURE__*/_mergeDefaults({
    readonly: { type: Boolean },
    disable: { type: Boolean },
    required: { type: Boolean },
    useWrapper: { type: Boolean },
    skipValidation: { type: Boolean },
    errorMessage: {},
    label: {},
    showHistory: { type: Boolean },
    history: {},
    modelValue: {},
    params: {}
  }, defaultValuedProps),
  emits: ["update:modelValue", "reveal-history"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;

const { innerValue, emitValue } = useValue<FieldValue<boolean> | null, FieldValue<boolean>>(
  props,
  emit,
  {
    transform: (value) => (!value || value.value == null ? { value: false } : value),
  }
);

const { params, validationRules } = useFieldParams<CheckboxFieldParams>(props);

const { hasHistory, revealHistory } = useBaseFieldProps(props, emit);

const tooltip = useTooltip(props);

return (_ctx: any,_cache: any) => {
  const _component_q_field = _resolveComponent("q-field")!

  return (_openBlock(), _createBlock(_component_q_field, {
    modelValue: _unref(innerValue).value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(innerValue).value) = $event)),
    borderless: "",
    "hide-bottom-space": "",
    class: _normalizeClass({ required: _ctx.required, 's-form-input_wrapper': _ctx.useWrapper }),
    rules: _unref(validationRules)
  }, _createSlots({
    default: _withCtx(() => [
      _createVNode(SCheckbox, {
        ref: "checkbox",
        modelValue: _unref(innerValue).value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_unref(innerValue).value) = $event)),
          _unref(emitValue)
        ],
        label: _ctx.label,
        disable: _ctx.readonly || _ctx.disable
      }, null, 8, ["modelValue", "label", "disable", "onUpdate:modelValue"])
    ]),
    _: 2
  }, [
    (_unref(tooltip) || (_ctx.showHistory && _unref(hasHistory)))
      ? {
          name: "prepend",
          fn: _withCtx(() => [
            (_unref(tooltip))
              ? (_openBlock(), _createBlock(Tooltip, {
                  key: 0,
                  text: _unref(tooltip)
                }, null, 8, ["text"]))
              : _createCommentVNode("", true),
            (_ctx.showHistory && _unref(hasHistory))
              ? (_openBlock(), _createBlock(FieldHistoryBtn, {
                  key: 1,
                  history: _ctx.history,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(revealHistory)(_ctx.label)))
                }, null, 8, ["history"]))
              : _createCommentVNode("", true)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue", "class", "rules"]))
}
}

})